module.exports = __webpack_public_path__ + "img/proxima-positive-with-symptons.92b8f8c0.png";